import { service } from '@maia/claim';
import { useMutation } from '@tanstack/react-query';

type UseCreateClaimParams = Parameters<typeof service.createNote>[1];

export function useCreateClaimNote(
  customerGuid: string,
  claimGuid: string,
  onSuccess?: () => void,
  onError?: () => void,
) {
  return useMutation({
    mutationFn: (args: UseCreateClaimParams) =>
      service.createNote(
        `customers/${customerGuid}/claims/${claimGuid}/notes`,
        args,
      ),
    onSuccess,
    onError,
  });
}
